import * as React from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { blankWaterMeter } from './NewWaterMeterDialog';

/**
 * @type {React.FunctionComponent<{
 *   isOpen: boolean;
 *   targetWaterMeter: object;
 *   allCompanies?: object[];
 *   onBind: () => void;
 *   onUnbind: () => void;
 *   onCancel: () => void;
 * }>}
 */
const ChangeWaterMeterBindingDialog = (props) => {
  const { isOpen, targetWaterMeter, allCompanies, onBind, onUnbind, onCancel } = props;

  const [waterMeter, setWaterMeter] = React.useState(blankWaterMeter);

  const isInputValid = React.useMemo(() => {
    if (waterMeter.houseId == null) return false;
    return true;
  }, [waterMeter]);

  React.useEffect(() => {
    setWaterMeter(targetWaterMeter ?? blankWaterMeter);
  }, [targetWaterMeter]);

  const selectedCompany = allCompanies
    ?.find((company) => company.id === waterMeter.companyId);
  const selectedBusiness = selectedCompany?.businesses
    ?.find((business) => business.id === waterMeter.businessId);
  const selectedFarm = selectedBusiness?.farms
    ?.find((farm) => farm.id === waterMeter.farmId);
  const selectedHouse = selectedFarm?.houses
    ?.find((house) => house.id === waterMeter.houseId);

  React.useEffect(() => {
    if (selectedCompany?.id !== waterMeter.companyId) {
      setWaterMeter((val) => ({ ...val, businessId: null, farmId: null, houseId: null }));
    }
  }, [selectedCompany, waterMeter.companyId]);
  React.useEffect(() => {
    if (selectedBusiness?.id !== waterMeter.businessId) {
      setWaterMeter((val) => ({ ...val, farmId: null, houseId: null }));
    }
  }, [selectedBusiness, waterMeter.businessId]);
  React.useEffect(() => {
    if (selectedFarm?.id !== waterMeter.farmId) {
      setWaterMeter((val) => ({ ...val, houseId: null }));
    }
  }, [selectedFarm, waterMeter.farmId]);

  return (
    <Dialog
      visible={isOpen}
      header={
        <>
          Change Water Meter Binding
        </>
      }
      footer={
        <div className="flex justify-content-between">
          <div>
            <Button label='Unbind' icon='pi pi-link' severity='danger' text onClick={() => {
              if (window.confirm('Unbind this device?')) {
                onUnbind(waterMeter)
              }
            }} />
          </div>
          <div>
            <Button label='Cancel' icon='pi pi-times' text onClick={() => onCancel()} />
            <Button label='Save' icon='pi pi-check' text onClick={() => onBind(waterMeter)} disabled={!isInputValid} />
          </div>
        </div>
      }
      style={{ width: '600px' }}
      blockScroll
      onHide={() => onCancel()}
    >
      <div className="flex flex-column gap-3">
        <div className="flex flex-column gap-2">
          <label>Company</label>
          <Dropdown
            value={waterMeter.companyId ?? null}
            options={allCompanies}
            filter
            placeholder="Select a company"
            optionLabel="name"
            optionValue="id"
            onChange={(event) => setWaterMeter((val) => ({ ...val, companyId: event.value }))}
          />
        </div>
        <div className="flex flex-column gap-2">
          <label>Business</label>
          <Dropdown
            value={waterMeter.businessId ?? null}
            options={selectedCompany?.businesses}
            placeholder="Select a business"
            optionLabel="name"
            optionValue="id"
            onChange={(event) => setWaterMeter((val) => ({ ...val, businessId: event.value }))}
          />
        </div>
        <div className="flex flex-column gap-2">
          <label>Farm</label>
          <Dropdown
            value={waterMeter.farmId ?? null}
            options={selectedBusiness?.farms}
            placeholder="Select a farm"
            optionLabel="name"
            optionValue="id"
            onChange={(event) => setWaterMeter((val) => ({ ...val, farmId: event.value }))}
          />
        </div>
        <div className="flex flex-column gap-2">
          <label>House</label>
          <Dropdown
            value={waterMeter.houseId ?? null}
            options={selectedFarm?.houses}
            placeholder="Select a house"
            optionLabel="name"
            optionValue="id"
            onChange={(event) => setWaterMeter((val) => ({ ...val, houseId: event.value }))}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default ChangeWaterMeterBindingDialog;
